import { ComponentStyleConfig } from '@chakra-ui/react';

import { primaryTextColor } from '../colors';
import { fontFamily } from '../font';

export const Table: ComponentStyleConfig = {
    baseStyle: {
        th: {
            color: primaryTextColor,
            fontFamily,
            fontWeight: 500,
            textAlign: 'center',
            textTransform: 'none',
            paddingX: 4,
            paddingY: 2
        },
        td: {
            paddingX: 4,
            paddingY: 2,
            textAlign: 'center',
            fontVariantNumeric: 'lining-nums'
        }
    },
    variants: {
        simple: {
            th: {
                color: 'black',
                borderBottomColor: 'grey.100',
                borderBottomWidth: '2px',
                fontSize: 16
            },
            tr: {
                _last: {
                    td: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    }
};
